export default __webpack_public_path__ + "static/media/nope_rooster.7ccf37c5.gif";